import institutionAPI from 'services/institutionAPI'
import { UnifiedPersonFilters } from 'CitizenProfile/types'

type Params = {
  entityKey: string
  filters: UnifiedPersonFilters
}

export default async function readCommonEntitiesOnCustomForm({ entityKey, filters }: Params) {
  const customFilters = {
    ...filters,
  }
  const response = await institutionAPI({
    method: 'POST',
    url: `/citizen-portal/service/${entityKey}`,
    data: entityKey === 'cities' ? customFilters : filters,
  })

  return response
}
